<template>
  <esg-base-dashboard-card title="온실가스 배출량"
                           :subtitle="`(제품군 - ${currentYear}년)`">
    <template #actions>
      <esg-base-select-box v-model="sort"
                           label="정렬"
                           size="sm">
        <option value="asc">오름차순</option>
        <option value="dsc">내림차순</option>
      </esg-base-select-box>
    </template>
    <firmwide-emission-by-product-family :sort="sort"/>
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import FirmwideEmissionByProductFamily from "../charts2/FirmwideEmissionByProductFamily.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  components: {
    EsgBaseSelectBox,
    FirmwideEmissionByProductFamily,
    EsgBaseDashboardCard
  },
  data() {
    return {
      sort: 'dsc'
    }
  }
}
</script>